import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState } from "../../types/rtk/auth/login";

const initialState: AuthState = {
  mail_token: undefined,
  token: undefined,
};

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<AuthState>) => {
      state.mail_token = action.payload.mail_token;
      state.token = action.payload.token;
    },
  },
});

export const { setAuth } = AuthSlice.actions;
const AuthReducer = AuthSlice.reducer;

export default AuthReducer;
